import type { RouteRecordRaw } from 'vue-router'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createWorkspaceRoutes = (prefix: string, withNames: boolean): RouteRecordRaw[] => [
  {
    path: `${prefix}workspace`,
    ...maybeRouteName(withNames, 'workspace'),
    component: () => import('@/views/workspace/Workbench.vue'),
    ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
    meta: {
      title: '工作台',
      ...(!withNames ? { legacyTenantRedirect: true } : {}),
    }
  }
]

const workspaceRoutes: RouteRecordRaw[] = [
  ...createWorkspaceRoutes('t/:tenantCode/', true),
  ...createWorkspaceRoutes('', false),
]

export default workspaceRoutes
